<template>
  <b-modal
           dialog-class="modal-dialog2"           
           body-class= "confirm-body"
           header-class="popup_header1"
           hide-footer
           centered
           @hidden="hide(); reset();"
           :visible="visible"
  >
    <template #modal-title>
      <span class="dlg_title1">{{$t('more.loan_calc')}}</span>
      <b-button class="input_reset_wrapper" @click="reset">
        <span class="input_reset">{{$t('common.reset')}}</span>
      </b-button>
    </template>
    <template #modal-header-close>
      <b-img class="dlg_close_btn" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <div class="align-vertical">
      <b-form-group
        class="c-row"
        label-cols="3"
        content-cols="9"
        label-class="loan_caption"
        :label="$t('more.loan_method')">
        <MFSelect
            class="input input_wrapper1"
            :vmodel="method == 0 ? '원리금균등분할상환' : method == 1 ? '만기일시상환' : '원금균등분할상환'"
            :drop="true"
            @change="(value) => {
              method = value == '원리금균등분할상환' ? 0 : value == '만기일시상환' ? 1 : 2
            }"
            :options="LOAN_METHOD"
          />
        <!-- <CSelect
          :options="LOAN_METHOD" v-model="method" class="right_align input input_wrapper1"/> -->
      </b-form-group>
      <b-form-group
        class="c-row"
        label-class="loan_caption"
        label-cols="3"
        content-cols="9"
        v-bind:label="$t('more.loan_principal')">
        <input-has-unit v-model="principal"
                        :formatter="val =>{return val.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}"
                        innerClass="input_wrapper1 input" :unit="$t('common.won')"/>


      </b-form-group>
      <b-form-group
        class="c-row"
        label-class="loan_caption"
        label-cols="3"
        content-cols="9"
        v-bind:label="$t('more.loan_period')">
        <input-has-unit v-model="period"
                        :formatter="val => {if (val > 999) val= 999; return val.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');}"
                        :unit="format_unit" right_padding="45"
        />
      </b-form-group>

      <b-form-group
        class="c-row"
        label-class="loan_caption"
        label-cols="3"
        content-cols="9"
        v-bind:label="$t('more.loan_interest_rate')">
        <input-has-unit
          v-model="interest_rate"
          :formatter="val => {if (val > 100) val= 100; return val.toString().replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');}"
          innerClass="input_wrapper1 input" unit="%" />
      </b-form-group>
            <b-table bordered
                     class="md_table"
                     :items="items"
                     :fields="fields">
              <template #cell(result)="data">
                {{data.value+' '+$t('common.won')}}
              </template>
            </b-table>
      <b-button-group style="height: 50px;">
        <b-button variant="none" @click="onViewMonth" squared class="btn_text md_btn_light" style="flex:1;border-style: none">{{$t('more.view_monthly_payment')}}</b-button>
        <b-button variant="none" @click="onCalculate" squared class="btn_text md_btn_primary" style="flex: 1; border-style: none">{{$t('more.calculate')}}</b-button>
      </b-button-group>
    </div>
    <MonthlyPopup
      :method="method"
      :principal="principal"
      :period="period"
      :rate="interest_rate"
      :visible.sync="showMonthlyPopup"
    />
  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
import InputHasUnit from "../InputHasUnit";
import CSelect from "../CSelect";
import MonthlyPopup from "./MonthlyPopup";
import MFSelect from "../mf/MFSelect";

const u = require('util');

const LOAN_METHOD = [
  '원리금균등분할상환',
  '만기일시상환',
  '원금균등분할상환',
];

const LOAN_DESC = [
  ['월평균 납입금', '총 납입이자', '월평균 이자'],
  ['월 납입이자', '총 납입이자', '총 상환금액'],
  ['월 평균납입금', '총 납입이자', '월평균 이자'],
];

export default {
  name: "LoanCalcPopup",
  components:{
    CSelect,
    InputHasUnit,
    MonthlyPopup,
    MFSelect
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      method:0,
      period:null,
      principal:null,
      interest_rate:null,
      avg_monthly_pay:'',
      total_interest_paid:'',
      avg_monthly_interest_amt:'',
      LOAN_METHOD:LOAN_METHOD,
      showMonthlyPopup:false,
      items:[],
      fields:[
        {key: "type", label: this.$t('more.division'), thClass: "md_table_header2", tdClass:"md_table_cell2", thStyle:"width:40%;"},
        {key: "result", label: this.$t('more.cal_result'), thClass: "md_table_header2", tdClass:"md_table_cell_right", thStyle:"width:60%;"},
      ],
   }
  },
  methods:{
    hide(){
      this.$emit('update:visible', false);
    },
    onViewMonth(){
      const {principal, period, interest_rate} = this;

      if (principal == null || period == null || interest_rate == null) {
        Utils.toast(this, this.$t('more.input_all'));
        return;
      }

      this.showMonthlyPopup = true;
    },

    onCalculate(){
      const {method, principal, period, interest_rate} = this;
      if (principal == null || period == null || interest_rate == null) {
        Utils.toast(this, this.$t('more.input_all'));
        return;
      }

      switch (method) {
        case 0:
          this.calc1();
          break;
        case 1:
          this.calc3();
          break;
        case 2:
          this.calc2();
          break;
        default:
          break;
      }
    },
    calc1(){
      let {principal, period, interest_rate} = this;

      principal = principal.replaceAll(',', '');
      period = period.replaceAll(',', '');
      interest_rate = interest_rate.replaceAll(',', '');

      let B = Number(interest_rate / 12) / 100;
      let denominator = (Math.pow(1 + B, period) - 1);
      let numerator = (principal * B * Math.pow(1 + B, period));

      let avg_monthly_pay = numerator / denominator;
      let avg_monthly_interest_amt = avg_monthly_pay - Number(principal) / Number(period);
      let total_interest_paid = avg_monthly_interest_amt * Number(period);

        this.items[0].result = Utils.currency(Math.round(avg_monthly_pay));
        this.items[1].result = Utils.currency(Math.round(total_interest_paid));
        this.items[2].result = Utils.currency(Math.round(avg_monthly_interest_amt));
    },

    calc2(){
      let {principal, period, interest_rate} = this;

      principal = principal.replaceAll(',', '');
      period = period.replaceAll(',', '');
      interest_rate = interest_rate.replaceAll(',', '');

      let monthly_pay = 0, total_monthly_pay = 0, monthly_principal = 0;
      let B = Number(interest_rate / 12) / 100;
      monthly_principal = Number(principal / period);

      let principal_total = principal;
      for (let ind = 1; ind <= period; ind++) {
        monthly_pay = Math.round(principal_total *  B);
        principal_total -= monthly_principal;
        total_monthly_pay = total_monthly_pay + monthly_pay;
      }

        this.items[0].result = Utils.currency(Math.round(monthly_principal + total_monthly_pay / period));
        this.items[1].result  = Utils.currency(Math.round(total_monthly_pay));
        this.items[2].result  = Utils.currency(Math.round(total_monthly_pay / period));
    },

    calc3(){
      let {principal, period, interest_rate} = this;

      principal = principal.replaceAll(',', '');
      period = period.replaceAll(',', '');
      interest_rate = interest_rate.replaceAll(',', '');

      let B = Number(interest_rate / 12) / 100;

        this.items[0].result  = Utils.currency(Math.round(principal * B));
        this.items[1].result = Utils.currency(Math.round(principal * B) * period);
        this.items[2].result = Utils.currency(Math.round(principal * B) * period + Number(principal));
    },
    reset(){
      this.principal=null;
      this.period=null;
      this.interest_rate=null;
      this.method = 0;
      this.items[0].result = '';
      this.items[1].result = '';
      this.items[2].result = '';
    }
  },
  computed:{
    format_unit() {
      return u.format(this.$t('map.month'), '');
    }
  },
  watch:{
    method(){
      for (let i = 0; i<3; i++){
        this.items[i].type = LOAN_DESC[this.method][i];
      }
    }
  },
  mounted() {
    for (let i = 0; i<3; i++){
      this.items.push({
        type:LOAN_DESC[0][i],
        result: '',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
.input {
  text-align: right;
  color: $black;
  font-size: $fs_17;
  font-family: $korean_gd_14_r;
}
.input_wrapper1{
  height: 40px;
  border: solid 1px #bebdbd;
  border-radius: 3px;
}

.input_reset_wrapper {
  background-color: #e6f0fd !important;
  width: 70px;
  height: 33px;
  margin-left: 5px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding:0;
  line-height: 0;
  border-style: none;
  margin-bottom: 2px;
}
.input_reset {
  color: #0840ba;
  font-size: $fs_17;
  font-family: $korean_gd_15_r;
}
.dlg_close_btn {
  width: 18px;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.c-row{
  margin-bottom: 11px;
}
.right_align{
  direction: rtl;
  padding-right: 2em;
}

.btn_text{
  color: white;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/LoanCalcPopup.vue